export const localConfig = {
  classes: {
    title: 'Classes',
    watchLater: true
  },
  courses: {
    title: 'Courses',
    watchLater: false
  },
  challenges: {
    title: 'Challenges',
    watchLater: false
  }
};
